module.exports = __webpack_public_path__ + "img/supplier_businessLicense.68cd2b77.png";